import { HIDE_TOOLTIP_FAVORITE_DISH } from '../actionTypes';

const hideTooltipFavoriteDish = () => ({
  type: HIDE_TOOLTIP_FAVORITE_DISH,
  payload: { title: '' },
});

export default hideTooltipFavoriteDish;
